import { render, staticRenderFns } from "./activity-calendar-event-form.vue?vue&type=template&id=2118c9b6&scoped=true&"
import script from "./activity-calendar-event-form.vue?vue&type=script&lang=ts&"
export * from "./activity-calendar-event-form.vue?vue&type=script&lang=ts&"
import style0 from "./activity-calendar-event-form.vue?vue&type=style&index=0&id=2118c9b6&lang=scss&scoped=true&"
import style1 from "./activity-calendar-event-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118c9b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VChip,VCol,VContainer,VForm,VIcon,VRadio,VRadioGroup,VRow,VTextField,VTextarea,VTooltip})
